export type DataStructure = {
  value: string
  label?: string
}

export enum RemoteWork {
  Remote = 'Remote',
  OnSite = 'On-site',
  Hybrid = 'Hybride',
}

export const masterdata = {
  careers: [
    {
      value: 'Geen ervaring',
    },
    {
      value: 'Starter',
    },
    {
      value: 'Ervaren',
    },
    {
      value: 'Leidinggevend',
    },
    {
      value: 'Senior management',
    },
    {
      value: 'Directie',
    },
  ],
  contractTypes: [
    {
      value: 'Vast',
    },
    {
      value: 'Tijdelijk',
    },
    {
      value: 'Freelance',
    },
    {
      value: 'Zelfstandig/Franchise',
    },
    {
      value: 'Interim',
    },
    {
      value: 'ZZP',
    },
    {
      value: 'Thuiswerk',
    },
    {
      value: 'Vakantiewerk',
    },
    {
      value: 'Stage',
    },
    {
      value: 'Bijbaan',
    },
    {
      value: 'Vrijwilliger',
    },
    {
      value: 'Leer-werk overeenkomst',
    },
  ],
  countries: [
    {
      value: 'NL',
      label: 'Nederland',
    },
    {
      value: 'DE',
      label: 'Duitsland',
    },
    {
      value: 'BE',
      label: 'België',
    },
    {
      value: 'LU',
      label: 'Luxemburg',
    },
  ],
  educations: [
    {
      value: 'Lagere school',
    },
    {
      value: 'LBO',
    },
    {
      value: 'VMBO/MAVO',
    },
    {
      value: 'HAVO',
    },
    {
      value: 'VWO',
    },
    {
      value: 'MBO',
    },
    {
      value: 'HBO',
    },
    {
      value: 'WO',
    },
    {
      value: 'Postdoctoraal',
    },
  ],
  industries: [
    {
      value: 'Accountancy',
    },
    {
      value: 'Advies/Consultancy',
    },
    {
      value: 'Afval en milieu',
    },
    {
      value: 'Automotive',
    },
    {
      value: 'Banken/Financiële dienstverlening',
    },
    {
      value: 'Beveiliging/Bewaking',
    },
    {
      value: 'Bouw/Installatie',
    },
    {
      value: 'Chemie/Petrochemie',
    },
    {
      value: 'Detailhandel',
    },
    {
      value: 'Elektronica',
    },
    {
      value: 'Energie/Gas/Water',
    },
    {
      value: 'Facilitaire dienstverlening',
    },
    {
      value: 'Farmacie',
    },
    {
      value: 'FMCG',
    },
    {
      value: 'Gezondheidszorg/Welzijn',
    },
    {
      value: 'Handel/Groothandel',
    },
    {
      value: 'Horeca',
    },
    {
      value: 'ICT',
    },
    {
      value: 'Industrie',
    },
    {
      value: 'Internet',
    },
    {
      value: 'Juridische dienstverlening',
    },
    {
      value: 'Kunst/Cultuur/Entertainment',
    },
    {
      value: 'Landbouw/Bosbouw/Visserij',
    },
    {
      value: 'Makelaardij/Vastgoed',
    },
    {
      value: 'Maritiem',
    },
    {
      value: 'Media/Uitgeverijen/TV',
    },
    {
      value: 'Mode/Textiel/Cosmetica',
    },
    {
      value: 'Onderwijs/Opleiding',
    },
    {
      value: 'Overheid/Non-profit',
    },
    {
      value: 'Personen vervoer',
    },
    {
      value: 'Reclame/PR/Communicatie',
    },
    {
      value: 'Sport/Recreatie/Toerisme',
    },
    {
      value: 'Techniek',
    },
    {
      value: 'Telecom',
    },
    {
      value: 'Transport/Opslag/Distributie',
    },
    {
      value: 'Uitzend/Detachering/W&S',
    },
    {
      value: 'Verzekeringen/Assurantiën',
    },
    {
      value: 'Zakelijke dienstverlening',
    },
    {
      value: 'Overig',
    },
  ],
  jobCategories: [
    {
      value: 'Administratief/Secretarieel',
    },
    {
      value: 'Automatisering/Internet',
    },
    {
      value: 'Beleid/Bestuur/Staf',
    },
    {
      value: 'Beveiliging/Defensie/Politie',
    },
    {
      value: 'Commercieel/Verkoop',
    },
    {
      value: 'Consultancy/Advies',
    },
    {
      value: 'Design/Creatie/Journalistiek',
    },
    {
      value: 'Directie/Management algemeen',
    },
    {
      value: 'Financieel/Accounting',
    },
    {
      value: 'Financiele dienstverlening',
    },
    {
      value: 'Horeca/Detailhandel',
    },
    {
      value: 'HR/Training/Opleiding',
    },
    {
      value: 'Inkoop/Logistiek/Transport',
    },
    {
      value: 'Juridisch',
    },
    {
      value: 'Klantenservice/Callcenter/Receptie',
    },
    {
      value: 'Marketing/PR/Communicatie',
    },
    {
      value: 'Medisch/Zorg',
    },
    {
      value: 'Onderwijs/Onderzoek/Wetenschap',
    },
    {
      value: 'Productie/Uitvoerend',
    },
    {
      value: 'Techniek',
    },
    {
      value: 'Overig',
    },
  ],
  remoteWork: [
    { value: RemoteWork.Remote, helpText: 'Het werk kan op elke, door de kandidaat gewenste, locatie worden uitgevoerd.' },
    { value: RemoteWork.OnSite, helpText: 'Het werk wordt grotendeels uitgevoerd op de locatie van de opdrachtgever.' },
    { value: RemoteWork.Hybrid, helpText: 'Het werk wordt afwisselend uitgevoerd op locatie van de opdrachtgever én op een door de kandidaat gewenste locatie. Het flexibel kiezen van je werklocatie is hier het uitgangspunt.' },
  ]
}
